import { Component, Input } from '@angular/core';

/**
 * Used to work around i18n limitations
 */
@Component({
    selector: '[render-part-of-day]',
    template: `
@switch (partOfDay) {
  @case (1) {
    <ng-container i18n="part of day - morning@@part.of.day.morning">
        morning
      </ng-container>
  }
  @case (2) {
    <ng-container i18n="part of day - afternoon@@part.of.day.afternoon">
        afternoon
      </ng-container>
  }
  @case (3) {
    <ng-container i18n="part of day - evening@@part.of.day.evening">
        evening
      </ng-container>
  }
}
`,
    standalone: true
})
export class RenderPartOfDayComponent {
  @Input() partOfDay: number;
}
